export const BAR_NAME = "MI.RO'";
export const CITY = "Napoli";
export const ADDRESS = "Piazza Carità 44, 80134 Napoli (NA)";
export const HOURS = [
  { d: "Lun – Gio", h: "07:00 – 22:00" },
  { d: "Ven – Sab", h: "07:00 – 23:00" },
  { d: "Domenica", h: "07:00 – 22:00" },
];

export const WHATSAPP_NUMBER = "393890415041";
export const PHONE_DISPLAY = "+39 389 0415041";
export const INSTAGRAM_HANDLE = "bar_miro_napoli";
export const INSTAGRAM_URL = "https://instagram.com/bar_miro_napoli";

export const waLink = (message = "") =>
  `https://wa.me/${WHATSAPP_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const waLinkTo = (phone, message = "") => {
  let p = (phone || "").replace(/\D/g, "");
  if (p.startsWith("00")) p = p.slice(2);
  if (p.length === 10 && p.startsWith("3")) p = "39" + p;
  return `https://wa.me/${p}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/14882031/pexels-photo-14882031.jpeg?auto=compress&cs=tinysrgb&w=1920",
  about: "https://images.unsplash.com/photo-1750820935982-729cd3f841c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  reserve: "https://images.unsplash.com/photo-1615887026505-00283cf0ff83?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gallery: [
    "https://images.unsplash.com/photo-1597075687490-8f673c6c17f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1607687633950-c745bdb4da70?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1678261739137-85881474209c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1593412323862-55bd8bb39099?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1775850201902-1418bc12594a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1615887026505-00283cf0ff83?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  ],
};

export const MENU = [
  {
    title: "Espresso Martini",
    desc: "Il nostro cavallo di battaglia: vodka, caffè espresso appena estratto e liquore al caffè.",
    price: "€ 9",
    img: "https://images.unsplash.com/photo-1607687633950-c745bdb4da70?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    title: "Caffè d'Autore",
    desc: "Selezione di caffè specialty, dall'espresso napoletano ai metodi filtro lenti.",
    price: "€ 3",
    img: "https://images.unsplash.com/photo-1593412323862-55bd8bb39099?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    title: "Aperitivo MI.RO'",
    desc: "Signature spritz e cocktail d'autore, accompagnati dal nostro tagliere partenopeo.",
    price: "€ 10",
    img: "https://images.unsplash.com/photo-1725396956227-7a6f315784c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];
